<template>
	<div>
		<v-overlay :value="isReloadingClienti">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>
		
		<v-data-table
			:headers="headers"
			:items="clienti"
			:search="search"
			:loading="isLoadingClienti"
			:footer-props="{
				'items-per-page-options': [5, 10, 25, 50, 100, -1]
			}"
			:items-per-page="50"
			height="calc(100vh - 207px)"
			fixed-header
			multi-sort
		>
			<template v-slot:item.quali_aggiornamenti_ci_sono_nelle_pratiche="{ item }">
				<div class="d-flex align-center">
					<v-icon
						v-if="item.quali_aggiornamenti_ci_sono_nelle_pratiche.ci_sono_aggiornamenti_per_account_manager"
						color="pink lighten-1"
						class="mr-1"
					>
						mdi-circle
					</v-icon>
					<v-icon
						v-if="item.quali_aggiornamenti_ci_sono_nelle_pratiche.ci_sono_aggiornamenti_fasi"
						color="secondary"
					>
						mdi-circle
					</v-icon>
				</div>
			</template>
			<template v-slot:item.actions="{ item }">
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openClienteDialog('edit', item)"
					>
						mdi-pencil
					</v-icon>
				</v-hover>
				
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openClienteDialog('show', item)"
					>
						mdi-text-box-search-outline
					</v-icon>
				</v-hover>
				
				<!--<v-hover v-if="" v-slot="{ hover }">-->
				<!--	<v-icon-->
				<!--		:class="`${hover ? 'error&#45;&#45;text' : ''}`"-->
				<!--		size="20"-->
				<!--		@click=""-->
				<!--	>-->
				<!--		mdi-delete-forever-->
				<!--	</v-icon>-->
				<!--</v-hover>-->
				
				<v-btn
					color="tertiary"
					@click="openAccordiDataTableDialog(item.id)"
					class="black--text mr-2"
					small
				>
					Accordi
				</v-btn>
				<!--@click="$emit('open-accordi-dialog', { cliente_id: item.id })"-->
				
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openSendCredentialsDialog(item)"
					>
						mdi-key
					</v-icon>
				</v-hover>
			</template>
		</v-data-table>
		
		<v-dialog
			v-model="showAccordiDataTableDialog"
			scrollable
			persistent
		>
			<v-card>
				<v-card-title class="text-h5">
					Accordi del Cliente
				</v-card-title>
				<v-card-text>
					<accordi
						:key="accordiKey"
						:cliente-id="clienteId"
						@reload-clienti="reloadClienti()"
					></accordi>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						class="black--text"
						@click="showAccordiDataTableDialog = false"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			:value="sendCredentialsDialog"
			persistent
			width="unset"
		>
			<send-credentials
				:key="sendCredentialsKey"
				@close="sendCredentialsDialog = false"
				:cliente="clienteToSendCredentials"
			></send-credentials>
		</v-dialog>
		
		<v-dialog
			:value="showClienteDialog"
			persistent
			scrollable
			max-width="800"
		>
			<store-edit-view-cliente
				:key="clienteKey"
				v-model="cliente"
				:action="action"
				:search="search"
				@close="showClienteDialog = false"
				@reload-clienti="reloadClienti()"
			></store-edit-view-cliente>
		</v-dialog>
		
		<v-dialog
			v-model="filtersDialog"
			scrollable
			persistent
			width="800px"
		>
			<clienti-filters
				@close="filtersDialog = false"
				@reload-clienti="getClienti()"
			></clienti-filters>
		<!--	@apply-clienti-filters="applyClientiFilters($event)" -->
		</v-dialog>
		
	</div>
</template>

<script>
import { eventBus } from '@/event-bus.js';
import {mapGetters} from "vuex";
export default {
	props: ['search'],
	data() {
		return {
			isLoadingClienti: false,
			isReloadingClienti: false,
			
			headers: [
				{ text: 'ID', value: 'id' },
				{ text: 'Tipologia', value: 'tipologia' },
				{ text: 'Codice Cliente', value: 'codice_cliente' },
				{ text: 'Ragione Sociale', value: 'ragione_sociale' },
				{ text: 'Nome', value: 'nome' },
				{ text: 'Cognome', value: 'cognome' },
				{ text: 'Email', value: 'email' },
				{ text: 'Numero Pratiche Totali', value: 'numero_pratiche_totali' },
				{ text: 'Numero Pratiche Bando', value: 'numero_pratiche_di_questo_bando' },
				{ text: 'Attività', value: 'quali_aggiornamenti_ci_sono_nelle_pratiche', sortable: false },
				{ text: 'Azioni', value: 'actions', width: '230px', sortable: false },
			],
			clienti: [],
			filters: {
				tipologie: null
			},
			
			accordiKey: 0,
			showAccordiDataTableDialog: false,
			clienteId: null,
			
			sendCredentialsKey: 0,
			clienteToSendCredentials: null,
			sendCredentialsDialog: false,
			
			clienteKey: 0,
			showClienteDialog: false,
			cliente: null,
			action: null,
			
			filtersDialog: false
		}
	},
	
	created() {
		this.getClienti();
	},
	
	watch: {
		isLoading(boolean) {
			this.$emit('is-loading', boolean)
		}
	},
	
	computed: {
		...mapGetters({
			appliedFilters: 'clientiFilters/appliedFilters'
		}),
		isLoading() {
			return this.isLoadingClienti;
		}
	},
	
	methods: {
		getClienti() {
			this.isLoadingClienti = true;
			return axios.get('/api/clienti', {
				params: {
					filters: this.appliedFilters
				}
			})
				.then(response => {
					this.clienti = response.data;
				})
				.finally(() => {
					this.isLoadingClienti = false;
				})
		},
		openClienteDialog(action, cliente = null) {
			this.cliente = cliente;
			this.action = action;
			this.clienteKey++;
			this.showClienteDialog = true;
		},
		openAccordiDataTableDialog(clienteId) {
			this.accordiKey++;
			this.clienteId = clienteId;
			this.showAccordiDataTableDialog = true;
		},
		openSendCredentialsDialog(cliente) {
			this.clienteToSendCredentials = Object.assign({}, cliente);
			this.sendCredentialsKey++;
			this.sendCredentialsDialog = true;
		},
		async reloadClienti() {
			this.isReloadingClienti = true;
			await this.getClienti();
			this.isReloadingClienti = false;
		},
		openClientiFiltersDialog() {
			this.filtersDialog = true;
		},
		// applyClientiFilters(filters) {
		// 	this.filters = Object.assign({}, filters);
		// 	this.getClienti();
		// }
	}
}
</script>

<style scoped>

</style>